/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total daily energy expenditure is your BMR multiplied by an activity factor — the calories you burn in a typical day including movement and exercise.`)
};

const es_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El gasto energético diario total es tu TMB multiplicada por un factor de actividad — las calorías que quemas en un día normal, incluyendo movimiento y ejercicio.`)
};

const de_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Gesamtumsatz (TDEE) ist dein BMR multipliziert mit einem Aktivitätsfaktor — die Kalorien, die du an einem typischen Tag einschließlich Bewegung und Training verbrennst.`)
};

const nl_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het totale dagelijkse energieverbruik is je BMR vermenigvuldigd met een activiteitsfactor — de calorieën die je op een gemiddelde dag verbrandt, inclusief beweging en sport.`)
};

const fr_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dépense énergétique totale quotidienne est votre BMR multiplié par un facteur d'activité — les calories que vous brûlez dans une journée type, mouvement et exercice inclus.`)
};

const it_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il dispendio energetico totale giornaliero è il tuo BMR moltiplicato per un fattore di attività — le calorie che bruci in una giornata tipica, incluso movimento ed esercizio.`)
};

const pt_br2_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O gasto energético total diário é a sua TMB multiplicada por um fator de atividade — as calorias que você queima em um dia comum, incluindo movimento e exercício.`)
};

const pt_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O gasto energético diário total é a sua TMB multiplicada por um fator de atividade — as calorias que queima num dia normal, incluindo movimento e exercício.`)
};

const ja_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総消費エネルギー量とは、基礎代謝量に活動係数を掛けたもので、運動を含む1日の生活で消費するカロリーのことです。`)
};

const zh_bmr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日总能量消耗是基础代谢率乘以活动系数——即包括日常活动和运动在内，一天所消耗的总热量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq_a2", locale)
	if (locale === "en") return en_bmr_faq_a2(inputs)
	if (locale === "es") return es_bmr_faq_a2(inputs)
	if (locale === "de") return de_bmr_faq_a2(inputs)
	if (locale === "nl") return nl_bmr_faq_a2(inputs)
	if (locale === "fr") return fr_bmr_faq_a2(inputs)
	if (locale === "it") return it_bmr_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq_a2(inputs)
	if (locale === "pt") return pt_bmr_faq_a2(inputs)
	if (locale === "ja") return ja_bmr_faq_a2(inputs)
	return zh_bmr_faq_a2(inputs)
};